/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React from 'react';
import { Card, Progress } from 'antd';
import { withTranslation } from 'react-i18next';

class MemoryInformationCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;
    return (
      <Card
        title={
          <span style={{ marginLeft: '30%' }}>{this.props.memoryType}</span>
        }
        bordered={true}
      >
        <Progress
          percent={
            ((parseFloat(this.props.totalMemory) -
              parseFloat(this.props.availableMemory)) /
              parseFloat(this.props.totalMemory)) *
            100
          }
          showInfo={false}
        />
        <br />
        <b>
          <span style={{ marginLeft: '25%' }}>
            {t('memory_infoTxt', {
              used:
                Math.round(
                  (parseFloat(this.props.totalMemory) -
                    parseFloat(this.props.availableMemory)) *
                    100,
                ) / 100,
              total: this.props.totalMemory,
            })}
          </span>
        </b>
      </Card>
    );
  }
}

export default withTranslation()(MemoryInformationCard);
